<template>
    <div
        :style="{ height: height, paddingTop: '56px' }"
        :class="{ 'w-3/5': sidebarVisible, 'w-full': ! sidebarVisible }"
    >
        <div id="field-sales-fullscreen" style="height: 100%">
            <adaptive-modal
                name="address-details"
                :hide-action-buttons="true"
                height="100%"
                content-height="100%"
            >
                <div
                    v-if="selectedAddress"
                    class="flex items-center flex-col"
                    style="height: 100%"
                >
                    <h2 class="headline-xl">
                        {{ selectedAddress.street_address_with_apartment_number }}
                    </h2>

                    <div
                        v-if="selectedAddress.latest_interaction"
                        :class="selectedAddress.latest_interaction.color"
                        class="text-xs font-bold mt-lg flex items-center"
                    >
                        <font-awesome-icon :icon="selectedAddress.latest_interaction.icon" class="mr-sm" />
                        {{ selectedAddress.latest_interaction.label }}
                    </div>
                    <div
                        v-else
                        :class="`text-${selectedAddress.status_color}`"
                        class="text-xs font-bold mt-lg flex"
                    >
                        {{ selectedAddress.status_label }}
                    </div>

                    <div
                        v-if="! selectedAddress.is_signed && customerPortalUrl"
                        style="margin-top: 6px; text-align: center; width: 100%;"
                    >
                        <a
                            :href="customerPortalUrl"
                            target="_blank"
                        >
                            <div class="card shadow-md" style="background: linear-gradient(18deg, #449b06, #a8e918);">
                                <span class="headline-md font-bold text-white" style="color: #ffffff !important; letter-spacing: .5px;">Customer Portal&ensp;<font-awesome-icon icon="arrow-right" /></span>
                            </div>
                        </a>
                    </div>

                    <iframe :src="route('field.sales.addresses.quickMenu', [selectedAddress])" style="background-color: lightgray; height: 100%; width: 100%" />

                    <button
                        type="button"
                        class="btn btn-lg is-primary mt-xl"
                        @click="goToAddress"
                    >
                        Visa adress
                    </button>
                </div>
            </adaptive-modal>
            <adaptive-modal
                name="address-mdu-details"
                :hide-action-buttons="true"
                height="80%"
                width="90%"
            >
                <div v-if="selectedAddress && selectedMduAddresses">
                    <h2 class="headline-lg text-center mb-xl">
                        Adresser på {{ selectedAddress.street_address }}
                    </h2>

                    <div v-for="address in selectedMduAddresses" class="mb-sm pb-sm border-b">
                        <div class="flex items-center justify-between">
                            <div class="">
                                <h3 class="headline-md">
                                    Lägenhet {{ address.apartment_number }}
                                </h3>
                                <div
                                    v-if="address.latest_interaction"
                                    :class="address.latest_interaction.color"
                                    class="text-xs mt-xs"
                                >
                                    <font-awesome-icon :icon="address.latest_interaction.icon" class="mr-xs" />
                                    {{ address.latest_interaction.label }}
                                </div>
                                <div
                                    v-else
                                    :class="`text-${address.status_color}`"
                                    class="text-xs ml-sm mt-xs"
                                >
                                    {{ address.status_label }}
                                </div>
                            </div>
                            <button
                                type="button"
                                class="btn btn-sm is-primary w-auto md:w-1/3"
                                @click="goToAddress"
                            >
                                Visa adress
                            </button>
                        </div>
                    </div>
                </div>
            </adaptive-modal>
            <base-map
                ref="baseMap"
                :markers="filteredMarkers"
                map-height="100%"
                :zoom="zoom"
                :disable-default-u-i="! isFieldView"
                :disable-fullscreen="true"
            >
                <gmap-marker
                    v-for="(marker, index) in filteredMarkers"
                    :key="index"
                    :icon="localMarkerIcon(marker)"
                    :position="markerPosition(marker)"
                    :clickable="clickable"
                    :draggable="false"
                    @click="showAddressInformation(marker)"
                />
            </base-map>
        </div>
    </div>
</template>

<script>
    import { markerIcon } from '../../mixins/MapMarkerIcon';
    import { filterAddressesFromSearch } from '../../mixins/FilterAddressesFromSearch';
    import BasicMapFunctionality from '../Maps/BasicMapFunctionality.js';

    export default {
        mixins: [BasicMapFunctionality],
        props: {
            height: {
                type: String,
                required: false,
                default: '81vh',
            },
            addresses: {
                type: Array,
                required: true,
            },
            project: {
                type: Object,
                default: null,
            },
            sidebarVisible: {
                type: Boolean,
                default: true,
            },
            selectedStatus: {
                type: String,
                default: 'mine',
            },
            search: {
                type: String,
                default: '',
            },
            zoom: {
                type: Number,
                required: false,
                default: 11,
            },
            clickable: {
                type: Boolean,
                default: true,
            },
            isFieldView: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {
                streets: {},
                addressesCount: 0,
                selectedAddresses: [],
                teams: {},
                selectedAddress: null,
                selectedMduAddresses: [],
            };
        },
        computed: {
            customerPortalUrl() {
                let customerPortalUrl = null;

                if (this.selectedAddress) {
                    switch (this.selectedAddress.country_code) {
                        case 'de':
                            customerPortalUrl = 'https://de.openinfra.com';
                            break;
                        case 'gb':
                            customerPortalUrl = 'https://uk.openinfra.com';
                            break;
                        case 'no':
                            customerPortalUrl = 'https://no.openinfra.com';
                            break;
                        case 'se':
                            customerPortalUrl = 'https://openinfra.com/se';
                            break;
                        case 'us':
                            customerPortalUrl = 'https://us.openinfra.com';
                            break;
                        default:
                            customerPortalUrl = null;
                    }
                }

                if (! customerPortalUrl) return null;

                return customerPortalUrl + '/?oip-view-access-selection-redirect=' + this.selectedAddress.reference_number;
            },
            filteredAddresses() {
                return filterAddressesFromSearch(this.addresses, this.search);
            },
            filteredMarkers() {
                return this.filteredAddresses;
            },
        },
        methods: {
            localMarkerIcon(marker) {
                return markerIcon(marker, this.getSalesCustomMapMarkerIcon(marker));
            },
            showAddressInformation(marker) {
                this.selectedAddress = this.addresses.find(address => address.id === marker.id);

                if (this.selectedAddress.apartment_number) {
                    this.selectedMduAddresses = this.getMduAddresses(this.selectedAddress);
                    this.$modal.show('address-mdu-details');
                } else {
                    this.selectedMduAddresses = [];
                    this.$modal.show('address-details');
                }
            },
            getMduAddresses(selectedAddress) {
                return this.addresses.filter(address => {
                    return address.full_address === selectedAddress.full_address;
                });
            },
            goToAddress() {
                window.location = route(
                    'field.sales.addresses.show', this.selectedAddress.id,
                );
            },
        },
    };
</script>
